import TextEdit from "./edit"
import TextView from "./view"

export default { view: TextView, edit: TextEdit }
